import {connect} from 'react-redux';

import TagFilter from '../components/tag-filter';

export default connect(
	(state) => ({
		selectedTag: state.app.selectedTag,
		tagHierarchy: state.tagHierarchy,
	}),
	(dispatch) => ({
		setSelectedTag: (selectedTag) =>
			dispatch({type: 'SET_SELECTED_TAG', selectedTag: selectedTag}),
	})
)(TagFilter);
